export const BASE_URL = 'https://api-talikasih.herokuapp.com/';
